<template>
  <v-app-bar elevation="0" class="topbar">
    <v-btn
      icon
      @click="toggleSidebar"
      class="hamburger-btn"
      :class="{ 'mobile-only': !isMobile }"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-toolbar-title class="mobile-title">
      <h3>{{ $route.name }}</h3>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="topbar-actions">
      <v-menu location="bottom end">
        <template #activator="{ props }">
          <v-btn icon v-bind="props" :title="themeButtonTitle">
            <v-icon>{{ themeIcon }}</v-icon>
          </v-btn>
        </template>
        <v-list density="compact" min-width="180">
          <v-list-item
            v-for="option in themeOptions"
            :key="option.value"
            :active="themeMode === option.value"
            @click="selectTheme(option.value)"
          >
            <template #prepend>
              <v-icon :icon="option.icon" size="small" />
            </template>
            <v-list-item-title>{{ option.label }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn icon href="/user">
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import { themeMode, setThemeMode, resolveThemeName } from "@/theme";

const THEME_OPTIONS = [
  { value: "system", label: "Match system", icon: "mdi-theme-light-dark" },
  { value: "light", label: "Light", icon: "mdi-white-balance-sunny" },
  { value: "dark", label: "Dark", icon: "mdi-weather-night" },
];

export default {
  name: "SimpleTopbar",
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    // themeMode is a module-level ref shared with src/theme.js, so the icon
    // stays correct even if the theme is changed from somewhere else.
    return { themeMode, setThemeMode };
  },
  data() {
    return {
      isMobile: false,
      themeOptions: THEME_OPTIONS,
    };
  },
  computed: {
    // In "system" mode show the neutral half-moon rather than pretending the
    // user picked the theme the OS happens to be on.
    themeIcon() {
      if (this.themeMode === "system") {
        return "mdi-theme-light-dark";
      }
      return this.themeMode === "dark"
        ? "mdi-weather-night"
        : "mdi-white-balance-sunny";
    },
    themeButtonTitle() {
      if (this.themeMode === "system") {
        return "Theme: matching system (" + resolveThemeName("system") + ")";
      }
      return "Theme: " + this.themeMode;
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 960;
    },
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    },
    selectTheme(mode) {
      this.setThemeMode(mode);
    },
  },
};
</script>

<style scoped>
.topbar {
  background: rgb(var(--v-theme-surface)) !important;
  border-bottom: 1px solid rgb(var(--v-theme-border-subtle));
}

.hamburger-btn {
  margin-right: 16px;
}

.mobile-only {
  display: none;
}

@media (max-width: 959px) {
  .mobile-only {
    display: flex;
  }
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.v-toolbar-title h3 {
  margin: 0;
  font-weight: 400;
  color: rgb(var(--v-theme-on-surface));
}

@media (max-width: 959px) {
  .mobile-title {
    flex: 1 1 auto !important;
    max-width: calc(100vw - 120px) !important;
  }

  .v-toolbar-title h3 {
    font-size: 0.9rem;
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
